import React from 'react';
import { Instagram } from 'lucide-react';
import { companyInfo } from '../data/mockData';

const Footer = ({ t }) => {
  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer className="bg-[#2C2C2C] text-[#FAF9F7] py-16">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12 mb-12">
          {/* Brand Column */}
          <div>
            <h3
              className="text-3xl font-light mb-4"
              style={{ fontFamily: 'Cormorant Garamond, serif' }}
            >
              {companyInfo.name}
            </h3>
            <p className="text-[#D4C4B0] leading-relaxed">
              {t.aboutSection.text.substring(0, 150)}...
            </p>
          </div>

          {/* Navigation Column */}
          <div>
            <h4 className="text-sm uppercase tracking-wider text-[#C4B5A0] mb-4 font-medium">
              Navigation
            </h4>
            <nav className="flex flex-col gap-3">
              <button
                onClick={() => scrollToSection('hero')}
                className="text-left text-[#FAF9F7] hover:text-[#C4B5A0] transition-colors"
              >
                {t.nav.home}
              </button>
              <button
                onClick={() => scrollToSection('services')}
                className="text-left text-[#FAF9F7] hover:text-[#C4B5A0] transition-colors"
              >
                {t.nav.services}
              </button>
              <button
                onClick={() => scrollToSection('about')}
                className="text-left text-[#FAF9F7] hover:text-[#C4B5A0] transition-colors"
              >
                {t.nav.about}
              </button>
              <button
                onClick={() => scrollToSection('contact')}
                className="text-left text-[#FAF9F7] hover:text-[#C4B5A0] transition-colors"
              >
                {t.nav.contact}
              </button>
              <a
                href="/politique-de-confidentialite"
                className="text-left text-[#FAF9F7] hover:text-[#C4B5A0] transition-colors"
              >
                Politique de confidentialité
              </a>
            </nav>
          </div>

          {/* Contact Column */}
          <div>
            <h4 className="text-sm uppercase tracking-wider text-[#C4B5A0] mb-4 font-medium">
              Contact
            </h4>
            <div className="space-y-3 text-[#FAF9F7]">
              <p>{companyInfo.location}</p>
              <a
                href={`mailto:${companyInfo.email}`}
                className="block hover:text-[#C4B5A0] transition-colors"
              >
                {companyInfo.email}
              </a>
              <a
                href={`tel:${companyInfo.phone}`}
                className="block hover:text-[#C4B5A0] transition-colors"
              >
                {companyInfo.phone}
              </a>
              <a
                href={companyInfo.instagramUrl}
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center gap-2 hover:text-[#C4B5A0] transition-colors mt-4"
              >
                <Instagram className="w-5 h-5" />
                <span>{companyInfo.instagram}</span>
              </a>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-[#8B7D6B] pt-8">
          <p className="text-center text-[#D4C4B0] text-sm">
            {t.footer.copyright}
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
